import gql from 'graphql-tag';

export default gql`
  fragment callNgReasonTemplateFragment on CallNgReasonTemplate {
    id
    clientId
    reason
  }
`;
